import { render, staticRenderFns } from "./LinkVerLocalizacaoRegistro.vue?vue&type=template&id=188a166f&scoped=true&"
import script from "./LinkVerLocalizacaoRegistro.vue?vue&type=script&lang=js&"
export * from "./LinkVerLocalizacaoRegistro.vue?vue&type=script&lang=js&"
import style0 from "./LinkVerLocalizacaoRegistro.vue?vue&type=style&index=0&id=188a166f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188a166f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
